/** @format */

import api from "../../../utils/api";
import { referenceService } from "../constant";
import { setStoreDB } from "../../../utils/StoreDB";
import {
  getCache,
  setCache,
  removeCacheByPrefix,
} from "../../../utils/cacheHelper";

const basePath = `${referenceService}`;

export const getTahun = async () => {
  const cached = getCache("tahun");
  if (cached) return cached;

  const response = await api.get(`${basePath}/tahun`);
  const data = response?.data?.return;
  if (data) setCache("tahun", data);
  return data;
};

export const postTahun = async (params: any) => {
  const response = await api.post(`${basePath}/tahun`, params);
  removeCacheByPrefix("tahun");
  return response?.data?.return;
};

export const deleteTahun = async (params: any) => {
  const response = await api.delete(`${basePath}/tahun/${params}`);
  removeCacheByPrefix("tahun");
  return response?.data?.return;
};

export const getTahunActive = async () => {
  const cached = getCache("tahun_active");
  if (cached) return cached;

  const response = await api.get(`${basePath}/tahun?activated=1`);
  setStoreDB("periodeTahunActive", response.data.return);
  const data = response?.data?.return;
  if (data) setCache("tahun_active", data);
  return data;
};
